import type { StaffMemberPayload } from '@Application/Facilities/StaffMembers/StaffMembers/Actions/staffMembersFetched';

export type StaffMemberCreatedPayload = StaffMemberPayload;

export type StaffMemberCreatedAction = {
	type: 'STAFF_MEMBER_CREATED';
	payload: StaffMemberCreatedPayload;
	organizationId: number;
};

export default (payload: StaffMemberCreatedPayload, organizationId: number): StaffMemberCreatedAction => ({
	type: 'STAFF_MEMBER_CREATED',
	payload,
	organizationId,
});
